import { render } from "./OnDemandExports.vue?vue&type=template&id=956d9dd0"
import script from "./OnDemandExports.vue?vue&type=script&lang=js"
export * from "./OnDemandExports.vue?vue&type=script&lang=js"

import "./OnDemandExports.vue?vue&type=style&index=0&id=956d9dd0&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__